import {Component} from '@angular/core';
import {CustomerService} from '../../../services/customers.service';
import {Customer} from '../../../models/customer.model';
import {Router} from '@angular/router';

@Component({
  providers: [CustomerService],
  styleUrls: ['./customer.add.component.scss'],
  selector: 'app-customers-add',
  templateUrl: './customer.add.component.html',
})
export class CustomersAddComponent {
  public customer: Customer = new Customer('Nieuwe klant');
  public error: string;

  constructor(private _customersService: CustomerService, public router: Router) {
  }

  public saveCustomer(): void {
    if (this.customer.name !== '') {
      this._customersService.create(this.customer)
        .subscribe(customer => {
          this.router.navigate(['/customers']);
        });
    } else {
      this.error = 'Naam is verplicht.';
    }
  }

  public cancel(): void {
    this.router.navigate(['/customers']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customer/add/customer.add.component.ts